import { defineStore } from 'pinia'
import { postData } from '@/data/api/fetchData'
import { getTokenFromCookie } from '@/utils/cookie'
import { setTokenInCookie } from '@/utils/cookie'
import { removeTokenFromCookie } from '@/utils/cookie'

export const useAuthStore = defineStore({
  id: 'auth',
  state: () => ({
    token: getTokenFromCookie() || null,
    firstName: localStorage.getItem('firstName') || '',
    lastName: localStorage.getItem('lastName') || '',
    email: localStorage.getItem('email') || '',
    isAllowedIspMonitor: localStorage.getItem('isAllowedIspMonitor') === 'true' || false,
    // RBAC: role is one of 'user' | 'admin' | 'superadmin', userType is 'internal' | 'external'.
    // Defaults keep this safe against a backend that hasn't rolled out RBAC fields yet.
    role: localStorage.getItem('role') || 'user',
    userType: localStorage.getItem('userType') || 'internal',
    resetFirstName: '',
    resetLastName: '',
    password: '',
    confirmPassword: '',
    recaptchaToken: null,
    loginIssue: null,
  }),
  getters: {
    isSuperAdmin: (state) => state.role === 'superadmin',
    isAdmin: (state) => state.role === 'admin' || state.role === 'superadmin',
    // external_manager can only create/manage external users - a narrower
    // scope than isAdmin, so it's kept as its own getter rather than folded
    // into isAdmin (which several other checks rely on meaning admin/superadmin).
    isExternalManager: (state) => state.role === 'external_manager',
    isExternal: (state) => state.userType === 'external',
  },
  actions: {
    async login(params) {
      console.log('params : ', params)
      try {
        const data = await postData(`login`, params)
        console.log(' login data: ', data)
        if (data.token) {
          this.token = data.token
          console.log('Token inside fetch : ', this.token)
          setTokenInCookie(this.token, 86400)
          this.firstName = data.f_name
          this.lastName = data.l_name
          this.email = params.email
          // RBAC fields: default gracefully if the backend hasn't sent them yet.
          this.role = data.role || data.Role || 'user'
          this.userType = data.user_type || data.userType || data.UserType || 'internal'
          localStorage.setItem('token', data.token)
          localStorage.setItem('firstName', data.f_name)
          localStorage.setItem('lastName', data.l_name)
          localStorage.setItem('email', params.email)
          localStorage.setItem('role', this.role)
          localStorage.setItem('userType', this.userType)
          this.loginIssue = null

          return true
        }
      } catch (error) {
        console.log(error)
      }
    },

    logout() {
      removeTokenFromCookie()
      localStorage.removeItem('firstName')
      localStorage.removeItem('lastName')
      localStorage.removeItem('email')
      localStorage.removeItem('isAllowedIspMonitor')
      localStorage.removeItem('role')
      localStorage.removeItem('userType')
      this.firstName = ''
      this.lastName = ''
      this.email = ''
      this.token = null
      this.isAllowedIspMonitor = false
      this.role = 'user'
      this.userType = 'internal'
    },

    updateLoginIssue(value) {
      this.loginIssue = value
    },

    setFirstName(value) {
      this.resetFirstName = value
    },

    setLastName(value) {
      this.resetLastName = value
    },

    setFinalName(f, l) {
      ;(this.firstName = f), (this.lastName = l)
    },

    setPassword(pass, cpass) {
      this.password = pass
      this.confirmPassword = cpass
    },
    setIsAllowedIspMonitor(value) {
      this.isAllowedIspMonitor = value
    },

    setRecaptchaToken(token) {
      this.recaptchaToken = token
    },
  },
})
